<div class="container single-view" id="view-card-order">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/card-orders" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CARD_ORDERS.BTN_BACK_TO_CARD_ORDER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="card-order-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'CARD_ORDER_SINGLE_VIEW.CARD_ORDER_DETAILS' | translate
            }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (cardOrderData.id) {
                  <span data-testid="card-order-name">{{ 'CARD_ORDER_SINGLE_VIEW.CARD_ORDER' | translate }} #{{ cardOrderData.id | defaultValue }}</span>
                }
                @if (cardOrderData.cardOrderingStatus) {
                  <span data-testid="card-order-status" class="tag"
                      [ngClass]="{
                        'tag-green': cardOrderData.cardOrderingStatus === cardOrderingStatus.CARD_ORDER_PRINTED,
                        'tag-blue': cardOrderData.cardOrderingStatus === cardOrderingStatus.CARD_ORDER_SENT_TO_PRINT,
                        'tag-orange': cardOrderData.cardOrderingStatus === cardOrderingStatus.CARD_ORDER_PARTIALLY_PRINTED,
                        'tag-gray': cardOrderData.cardOrderingStatus === cardOrderingStatus.CARD_ORDER_CREATED }">
                  {{ cardOrderData.cardOrderingStatus | cardOrderingStatus }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap">
            <span class="flex items-center mr-2" pTooltip="{{ 'CARD_ORDER_SINGLE_VIEW.TOOLTIP_RETAILER' | translate }}" tooltipPosition="top"><i class="icon icon-retailer mr-1"></i>
            <span data-testid="card-order-retailername">{{ cardOrderData.retailerName | defaultValue }}</span>
          </span>
          <span class="flex items-center mr-3" pTooltip="{{ 'CARD_ORDER_SINGLE_VIEW.TOOLTIP_REQUESTER' | translate }}" tooltipPosition="top"><i class="icon icon-user mr-1"></i>
          <span data-testid="card-order-createdby">{{ cardOrderData.createdByFullName | defaultValue }}</span>
        </span>
        <span class="flex items-center mr-2" pTooltip="{{ 'CARD_ORDER_SINGLE_VIEW.TOOLTIP_REQUEST_DATE' | translate }}" tooltipPosition="top"><i class="icon icon-calendar-tick mr-1"></i>
        <span data-testid="card-order-createdon">{{ cardOrderData.createdOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</span>
      </span>
    </div>
    <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
      @if (delete) {
        <button data-testid="delete-btn" class="btn red-btn" (click)="showDeleteDialog()">{{ 'CARD_ORDERS.BTN_DELETE' | translate }}</button>
      }
    </div>
  </div>
</div>
<hr role="presentation" class="w-full mb-3 mt-6 border-t">
<div class="view-content-wr">
  <div class="row">
    <div class="flex flex-col col-12 mb-2 text-wr">
      <!-- main content -->
      <section class="row">
        <div class="col-12">
          <h4>{{ 'CARD_ORDER_SINGLE_VIEW.DETAILS' | translate }}</h4>
          <hr role="presentation" class="w-full mb-2 mt-3 border-t">
          <dl class="details-grid">
            <dt data-testid="card-order-shipping-retailer-label" class="label grid-cols-1 pt-3">{{ 'CARD_ORDER_SINGLE_VIEW.SHIPPING_RETAILER' | translate }}</dt>
            <dd data-testid="card-order-shipping-retailer" class="value pt-3 pb-3">
              @if (cardOrderData.retailerId && allowViewRetailer) {
                <a [routerLink]="['/retailers/', cardOrderData.retailerId]" class="inline-flex items-center link">{{ cardOrderData.retailerName }}</a>
              } @else {
                {{ cardOrderData.retailerName }}
              }
            </dd>

            <dt data-testid="card-order-retailer-code-label" class="label grid-cols-1 pt-3">{{ 'CARD_ORDER_SINGLE_VIEW.RETAILER_CODE' | translate }}</dt>
            <dd data-testid="card-order-retailer-code" class="value pt-3 pb-3">{{ cardOrderData.retailerCode | defaultValue }}</dd>

            <dt data-testid="card-order-retailer-address-label" class="label grid-cols-1 pt-3">{{ 'CARD_ORDER_SINGLE_VIEW.RETAILER_ORIGIN_ADDRESS' | translate }}</dt>
            <dd data-testid="card-order-retailer-address" class="value pt-3 pb-3">{{ cardOrderData.retailerAddress }}</dd>

            <dt data-testid="card-order-createdby-label"  class="label grid-cols-1 pt-3">{{ 'CARD_ORDER_SINGLE_VIEW.REQUESTED_BY' | translate }}</dt>
            <dd data-testid="card-order-createdby"  class="value pt-3 pb-3">
              @if (cardOrderData.createdById && allowViewUser) {
                <a [routerLink]="['/users/', cardOrderData.createdById]" class="inline-flex items-center link">{{ cardOrderData.createdByFullName | defaultValue }}</a>
              } @else {
                {{ cardOrderData.createdByFullName | defaultValue }}
              }
            </dd>

            <dt data-testid="card-order-createdon-label" class="label grid-cols-1 pt-3">{{ 'CARD_ORDER_SINGLE_VIEW.REQUEST_DATE' | translate }}</dt>
            <dd data-testid="card-order-createdon" class="value pt-3 pb-3">{{ cardOrderData.createdOn | date: 'dd-MM-yyyy HH:mm' }}</dd>
          </dl>
        </div>

        <div class="col-12 mt-4">
          <h4>
            {{ 'CARD_ORDER_SINGLE_VIEW.DESTINATION' | translate }}
          </h4>
          <hr role="presentation" class="w-full mb-4 mt-3 border-t">

          @if (groupedRetailerItems.length) {
            @for (group of groupedRetailerItems; track trackByRetailerGroup($index, group)) {
              <section class="mb-6 destination-wr">
                <h4 data-testid="card-order-item-details" class="mb-2 destination-title px-3 py-3">
                  {{ 'CARD_ORDER_SINGLE_VIEW.RETAILER_NAME' | translate }}: <a [routerLink]="['/retailers/', group.retailerId]" class="inline-flex items-center link">{{ group.retailerName | defaultValue }}</a> ({{ group.items.length }})
                </h4>
                @if (getPaginatedItems(group); as paginatedGroupItems) {
                  @if (paginatedGroupItems.length) {
                    <dl class="details-grid">
                      @for (item of paginatedGroupItems; track trackByCardOrderItemId($index, item)) {
                        <dt data-testid="card-order-serialnumber-label" class="label grid-cols-1 px-3 py-3">
                          {{ 'CARD_ORDER_SINGLE_VIEW.SERIAL_NUMBER' | translate }}
                        </dt>
                        <dd data-testid="card-order-serialnumber" class="value px-3 py-3">
                          {{ item.serialNumber | defaultValue }}
                        </dd>
                      }
                    </dl>
                  }
                }
                <app-custom-paginator
                  data-testid="paginator"
                  [pageNumber]="getGroupPaginatorPageNumber(group)"
                  [rows]="group.paginatorRows"
                  [totalRecords]="group.items.length"
                  [rowsPerPageOptions]="rowsPerPageOptions"
                  [showCurrentPageReport]="true"
                  [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                  [disabled]="!group.items.length"
                  [alwaysShow]="false"
                  [showFirstLastIcon]="true"
                  [showPageLinks]="true"
                  [showPageSizeSelector]="true"
                  (onPageChange)="onGroupPageChange($event, group)">
                </app-custom-paginator>
              </section>
            }
          } @else {
            <p data-testid="card-order-empty-view">
              {{ 'CARD_ORDER_SINGLE_VIEW.NO_ORDERING_ITEMS_FOUND' | translate }}
            </p>
          }

        </div>

      </section>
      <!-- /main content -->
    </div>
  </div>
</div>
</div>
</div>
</div>

<!-- Delete card order -->
<dialog-reason  #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_CARD_ORDER'" (onClose)="deleteCardOrder($event)"></dialog-reason>
